export default "__VITE_ASSET__0b8f6345__"